//File to handle project schedule activities related features like
//Add activity, modify activity, delete activity, gantt chart display
//Gantt chart developed using Syncfusion, install the same
//npm install syncfusion/ej2-react-gantt
import React, { useState, useEffect, Children,useRef } from 'react';
import {
  GanttComponent,
  ColumnsDirective,
  ColumnDirective,
  Edit,
  CriticalPath,
  Inject,
  PdfExport,
  DayMarkers,
  Toolbar,
  Selection,
  //  TimelineViewMode,
  UndoRedo,
  VirtualScroll,
  AddDialogFieldsDirective,
  EditDialogFieldsDirective,
  RowDD,
  EditDialogFieldDirective,
  AddDialogFieldDirective,
  ExcelExport,
  HolidaysDirective,
  HolidayDirective,
  Resize,
  Reorder,
  CellEditArgs,
} from '@syncfusion/ej2-react-gantt';
import './Gantt.css';
import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-react-gantt/styles/material.css';
import jsPDF from 'jspdf';

import { Grid, MenuItem, TextField, Box, Button, Menu, IconButton, } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Checkbox, FormControlLabel, } from '@mui/material';
import axios from 'axios';
import BasicTable, { Column } from '../../components/table';
import { Activity } from './ProjectInterfaces';
import { BASEURL, StyledSelect } from '../../constants/Common';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Backdrop, CircularProgress } from '@mui/material';
import getTheme from '../../theme/theme';
import { ThemeProvider } from '@mui/material';
import { MultiSelect, CheckBoxSelection, } from '@syncfusion/ej2-react-dropdowns';
import moment from 'moment';
import { TasksEvent } from './ProjectInterfaces';
import FloatingButton from '../../pages/usersupport/helpdesk/FloatingButton';
import ConfirmationDialog from "../../components/ConfirmationDialog";
//import ProjectScheduleListview from './ProjectScheduleListview';
import autoTable from 'jspdf-autotable';
import logo from '../../assets/logo/brix logo1.png';
import * as XLSX from 'xlsx';
//import { ButtonComponent, SwitchComponent } from '@syncfusion/ej2-react-buttons';

import { registerLicense } from '@syncfusion/ej2-base';

//registerLicense('Ngo9BigBOggjHTQxAR8/V1NCaF5cXmZCeUx0QXxbf1x0ZFNMZF1bRHJPMyBoS35RckVlW3tednBURmVbWEV1');
//registerLicense('ORg4AjUWIQA/Gnt2U1hhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5UdkZjUX1bdH1VRmFZ');
// registerLicense(
//   'Ngo9BigBOggjHTQxAR8/V1NDaF5cWGNCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXZcdXRcQmRZVUdxV0Q='
// );

registerLicense('Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH5cd3RSQ2FZVEZwWko=')

interface Project {
  id: number;
  name: string;
  tasks: GanttTask[];
  expanded?: boolean; // Optional property for initial expansion
}

interface GanttTask {
  id: number;
  TaskID: string;
  TaskName: string;
  Description: string;
  StartDate: Date; // Assuming ISO 8601 format for dates
  Progress: number;
  Duration: number;
  employees: string;
  contractors: string;
  BaselineStartDate: Date;
  BaselineDuration: number;
  BaselineEndDate: Date;
  color: string;
  Predecessor: string;
  //child: 'subtasks'
  subtasks?: GanttTask[];
  children?: number[];
}

interface ColumnConfig {
  field: string;
  headerText: string;
  width: string;
  isPrimaryKey?: boolean;
  format?: string;
  visible: boolean;
  editType?: string;
  clipMode?: string;
}

interface ProjectScheduleEditProps {
  arg_projectid: number; // Pass selected project id
  arg_projectcode: string; // Pass selected project code
  arg_projectname: string;
  project_startdate:string;
  project_enddate:string;
  project_empolyees:any;
  project_contractors:any;
  activityData: Activity[];
  setActivityData: (Activity: Activity[]) => void; // Function to update activity data
  tasks: GanttTask[];
  setTasks: (tasks: GanttTask[]) => void;
}

//logo basecode url for pdf customize
export let logogantt =
  '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';

const ProjectScheduleEdit2: React.FC<ProjectScheduleEditProps> = ({
  arg_projectid,
  arg_projectcode,
  arg_projectname,
  project_startdate,
  project_enddate,
  project_empolyees,
  project_contractors,
  activityData,
  setActivityData,
  tasks,
  setTasks,
}) => {

  //  const [isProjectExpanded, setIsProjectExpanded] = useState(true);
  const [projects, setProjects] = useState<Project[]>([]);
  //const [editMode, setEditMode] = useState<boolean>(false); // State to track edit mode
  const [editMode, setEditMode] = useState<boolean>(true); // always true, in future version this will be used
  const [selProjectId, setSelProjectId] = useState<number>(0);
  ///   const [activityData, setActivityData] = useState<Activity[]>([]);
  //    const [tasks, setTasks] = React.useState<GanttTask[]>([]);  //for gantt chart
  const [taskDetails, setTaskDetails] = useState<TasksEvent[]>([]); //for calendar view
  const location = useLocation();
  const [selChartView, setSelChartView] = useState<number>(0);
  //const selectedProjectTitle = useSelector((state: RootState) => state.project.selectedProjectTitle);
  //const [rowsChartTable, setRowsChartTable] = useState<any>([]); //for gantt editable table
  const [rows_listview, setRowsListview] = useState<any>([]);  //For syncfusion grid table
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const [sourceWBS, setSourceWBS] = useState<string>('');
  const [targetWBS, setTargetWBS] = useState<string>('');

  const [openColumn, setOpenColumn] = useState(false);
  const [openWBSDialog, setOpenWBSDialog] = useState(false);
  const [ChartColumns, setChartColumns] = useState<Column[]>([]);
  const [isNotifyButtonDisabled, setIsNotifyButtonDisabled] = useState(false);
  const [isCriticalPathEnabled, setIsCriticalPathEnabled] = useState(false);
  const [ganttKey, setGanttKey] = useState(0);
  
  const toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    'Change WBS',
    'Reorder WBS',
    ///    'Undo',
    ///    'Redo',
    'ZoomIn',
    'ZoomOut',
    'ZoomToFit',
    'CriticalPath',
    ///   'PdfExport'
  ];
  //  const [timelineView, setTimelineView] = useState<TimelineViewMode>('Month');
  const splitterSettings: any = { position: '35%' };
  const [showBaseline, setShowBaseline] = useState<boolean>(false);
  const [selectedEmployees, setSelectedEmployees] = useState<string[]>([]);
  const [selectedContractors, setSelectedContractors] = useState<string[]>([]);

 
  const projectemployeesnames = JSON.parse(
    localStorage.getItem('names') || '[]'
  );

  // console.log("projectemployeesnames:",projectemployeesnames);

  const projectcontractornames = JSON.parse(
    localStorage.getItem('contractorsname') || '[]'
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  //  const [holidayDates, setHolidayDates] = useState<Holiday[]>([]);
  let userCategory = localStorage.getItem('usercategory');
  if (
    userCategory &&
    userCategory.startsWith('"') &&
    userCategory.endsWith('"')
  ) {
    userCategory = userCategory.slice(1, -1); // Remove first and last characters (quotes)
  }
  const [confirmOpen, setConfirmOpen] = useState(false);
  ///  const is_admin = userCategory?.toLowerCase() === 'admin';
  const userraccess = JSON.parse('' + localStorage.getItem('userrole'));
const scheduleAccess = userraccess?.scheduleaccess;
// console.log("scheduleAccess:",scheduleAccess);
  const workweekdays = localStorage.getItem('getWorkWeek');
  const orgid = localStorage.getItem('orgid');
  MultiSelect.Inject(CheckBoxSelection);

  const holidayDatesandLabels = location.state?.holidayDates || [];
  useEffect(() => {
    // console.log("Project Start Date: ", project_startdate);
    // You can now use project_startdate here
}, [project_startdate,project_enddate]);

const daysToSubtract = 4;
// Convert the string to a Date object

const parsedDate = new Date(project_startdate);

// Subtract days from the date
parsedDate.setDate(parsedDate.getDate() - daysToSubtract);

// Format the result as YYYY-MM-DD
const yearprojt = parsedDate.getFullYear();
const monthprojt = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based
const dayprojt = String(parsedDate.getDate()).padStart(2, "0");

const startDateproject = `${yearprojt}-${monthprojt}-${dayprojt}`;



const daysToAdd = 6; // Number of days to add

// Convert the string to a Date object
const parsedDates = new Date(project_enddate);

// Add days to the date
parsedDates.setDate(parsedDates.getDate() + daysToAdd);

// Format the result as YYYY-MM-DD
const yearprojt1 = parsedDates.getFullYear();
const monthprojt1 = String(parsedDates.getMonth() + 1).padStart(2, "0"); // Months are 0-based
const dayprojt1 = String(parsedDates.getDate()).padStart(2, "0");

const endDateproject = `${yearprojt1}-${monthprojt1}-${dayprojt1}`;

// console.log(endDateproject); // Logs the new end date after adding 4 days



const namesArray = project_empolyees
  .split(',')
  .map((name: any) => name.trim())
  .filter((name: any) => name.length > 0);  // Filter out empty names

const employees = namesArray.length > 0
  ? namesArray.map((name: any, index: any) => ({
      employeeId: index + 1, // Assign a unique ID starting from 1
      employeeName: name,
    }))
  : [];  


  const contractorsArray = project_contractors
  .split(',')
  .map((name: any) => name.trim())
  .filter((name: any) => name.length > 0);  // Filter out empty names

const contractors = contractorsArray.length > 0
  ? contractorsArray.map((name: any, index: any) => ({
    contractorsId: index + 1, // Assign a unique ID starting from 1
    contractorsName: name,
    }))
  : [];  

  // let ChartColumnsArray: Column[] = [  //To show/hide columns in grid using select column dialog
  //   { id: 'TaskName', label: 'Activity Name', align: 'center', isVisible: true, },
  //   // { id: 'Description', label: 'Description', align: 'left', isVisible: true },
  //   { id: 'StartDate', label: 'Start Date', align: 'left', isVisible: true },
  //   { id: 'Duration', label: 'Duration', align: 'left', isVisible: true },
  //   { id: 'Progress', label: 'Progress', align: 'left', isVisible: true },
  //   // { id: 'employees', label: 'Employees', align: 'left', isVisible: true },
  //   // { id: 'contractors', label: 'Contractors', align: 'left', isVisible: true },
  //   ///  { id: 'Color', label: 'Color', align: 'left', isVisible: true },
  //   { id: 'BaselineStartDate', label: 'Baseline Start Date', align: 'left', isVisible: true, },
  //   ///    { id: 'BaselineEndDate', label: 'Baseline End Date', align: 'left', isVisible: true, },
  //   // { id: 'BaselineDuration', label: 'Baseline Duration', align: 'left', isVisible: true, },
  //   { id: 'Predecessor', label: 'Predecessor', align: 'left', isVisible: true, },
  // ];

   const ListviewColumn: Column[] = [
     { id: 'activity_wbs', label: 'WBS', align: 'left' },
     { id: 'activity_name', label: 'Activity Name', align: 'left' },
     { id: 'activity_start_date', label: 'Start Date', align: 'left' },
     { id: 'activity_end_date', label: 'End Date', align: 'left' },
     { id: 'activity_duration', label: 'Duration', align: 'left' },
     { id: 'assigned_employees', label: 'Assigned Employess', align: 'left' },
     { id: 'assigned_contractors', label: 'Assigned Contractors', align: 'left', },
   ];



  const taskFields = {   //Input Fields for Gantt chart
    id: 'TaskID',
    name: 'TaskName',
    description: 'Description',
    startDate: 'StartDate',
    duration: 'Duration',
    progress: 'Progress',
    employees: 'Employees',
    contractors: 'Contractors',
    color: 'Color',
    baselineStartDate: 'BaselineStartDate',
    baselineEndDate: 'BaselineEndDate',
    baselineDuration: 'BaselineDuration',
    child: 'subtasks',
    dependency: 'Predecessor',
  };

  const initialColumns: ColumnConfig[] = [
    //Chart table column visibility, width declared here
    { field: 'TaskID', headerText: 'WBS', width: '80', isPrimaryKey: true, visible: true, },
    { field: 'TaskName', headerText: 'Activity Name', width: '130', visible: true, clipMode: 'EllipsisWithTooltip', },
    { field: 'StartDate', headerText: 'Start Date', width: '100', format: 'yyyy-MM-dd', visible: true },
    { field: 'Duration', headerText: 'Duration', width: '90', visible: true },
    { field: 'Progress', headerText: 'Progress', width: '90', visible: true },
    { field: 'employees', headerText: 'Employees', width: '100', visible: true, },
    { field: 'contractors', headerText: 'Contractors', width: '150', visible: true, },
    {
      field: 'BaselineStartDate', headerText: 'Baseline Start Date',
      width: '150', format: 'yyyy-MM-dd', visible: true,
    },
    ///    { field: 'BaselineEndDate', headerText: 'Baseline End Date', width: '150', format: 'yyyy-MM-dd', visible: true,},
    { field: 'BaselineDuration', headerText: 'Baseline Duration', width: '150', visible: true, },
    { field: 'Predecessor', headerText: 'Predecessor', width: '100', visible: true, },
    { field: 'color', headerText: 'Color', width: '90', visible: true },
    { field: 'Description', headerText: 'Description', width: '150', visible: true, },
  ];

  const [columns, setColumns] = useState<ColumnConfig[]>(initialColumns);
  let ganttChart: any;

  useEffect(() => {
    setIsLoading(true);

    let l_selectedProjectId = arg_projectid;
    // console.log("l_selectedProjectId:",l_selectedProjectId);
    fetchProjectActivities(l_selectedProjectId);
    setSelProjectId(l_selectedProjectId);

    const newProject: Project = {
      id: l_selectedProjectId, // Replace with an actual ID generation mechanism
      name: arg_projectcode,
      tasks: [],
      expanded: true, // Initially expanded
    };
    setProjects([...projects, { ...newProject, tasks: [], expanded: true }]);
    setIsLoading(false);
  }, []);


  useEffect(() => {
    if (scheduleAccess === 'View Only') {
        setEditMode(false); // Disable edit mode if access is 'View Only'
    } else {
        setEditMode(true); // Enable edit mode otherwise
    }
}, [scheduleAccess]); // Effect runs whenever `scheduleAccess` changes

  // Update rowsChartTable whenever activityData changes
  useEffect(() => {
    // Map activityData to rowsChartTable format
    setIsLoading(true);

    if (activityData.length !== 0) {
      const updatedRowsChartTable = activityData.map(
        (activity: Activity, index: any) => ({
          id: activity.id,
          activity_wbs: activity.activity_wbs,
          activity_name: activity.project_code
            ? activity.project_code + ' - ' + activity.activity_name
            : activity.activity_name,
          //activity_name: activity.activity_name,
          activity_start_date: activity.activity_start_date,
          activity_progress: activity.activity_progress,
          activity_duration: activity.activity_duration,
          activity_predecessors: activity.activity_predecessors,
        })
      );

      // Set the updated rowsChartTable
      //setRowsChartTable(updatedRowsChartTable);

      /*
      let l_rows_listview = activityData?.map(
        (activity: Activity, index: any) => ({
          activity_wbs: activity.activity_wbs,
          activity_name: activity.project_code
            ? activity.project_code + ' - ' + activity.activity_name
            : activity.activity_name,
          activity_start_date: activity.activity_start_date,
          activity_end_date: activity.activity_end_date,
          activity_duration: activity.activity_duration,
          assigned_employees: activity.employees,
          assigned_contractors: activity.contractors,
          assigned_color: activity.color,
        })
      );
      setRowsListview(l_rows_listview);
*/
      populateListviewTable(activityData)

      ///         populateGanttTasks(activityData);
    }
    // setChartColumns(ChartColumnsArray);
    setIsLoading(false);
    // setGanttKey((prev) => prev + 1);
    // Delay setGanttKey until after rows are processed
      // setTimeout(() => setGanttKey((prev) => prev + 1), 100);
  }, [activityData]); // Run this effect whenever activityData changes

  

  const fetchProjectActivities = async (projectid: any) => {
    //To fetch status of all projects from projects table
    setIsLoading(true);
    try {
      if (Number.isNaN(projectid)) projectid = 0;
      const act_url = `${BASEURL}/projects/activities?projectids=${projectid}&orgid=${orgid}`;
      const response = await axios.get(act_url, {
        headers: { Accept: 'application/json' },
      });

      const act_data = response.data.activities;
      if (act_data) {
        setActivityData(act_data);
        sortByWBS(act_data)
        populateGanttTasks(act_data);
        populateTasksDetails(act_data);

      }
      ///    fetch_emp_contracts_names();
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong while fetching the activities details, please contact helpdesk.")
    }

    setIsLoading(false);
  };

  const populateGanttTasks = (activityData: any[]) => {
    //to populate gantt chart table
    /*
        const tasks: Task[] = activityData.map((activity: any) => ({
            //            id: activity.id + "",
            id: activity.activity_wbs,
            type: activity.activity_type,
            name: activity.project_code + " - " + activity.activity_name,
            start: new Date(activity.activity_start_date),
            end: new Date(activity.activity_end_date),
            progress: activity.activity_progress,
            //            dependencies: findActivityIdByWBS(activity.activity_predecessors)
            dependencies: [activity.activity_predecessors],
        }));
        setTasks(tasks);
*/

    const clonedData = structuredClone(activityData);

    //    const gantttasks: GanttTask[] = activityData.map((activity: any) => ({
    const gantttasks: GanttTask[] = clonedData.map((activity: any) => ({
      id: activity.id,
      TaskID: activity.activity_wbs,
      color: activity.color,
      TaskName: arg_projectcode
        ? arg_projectcode + ' - ' + activity.activity_name
        : activity.activity_name,
      Description: activity.activity_description,
      StartDate: new Date(activity.activity_start_date),
      EndDate: new Date(activity.activity_end_date),
      Progress: activity.activity_progress,
      Duration: activity.activity_duration,
      employees: activity.employees,
      contractors: activity.contractors,
      BaselineStartDate: activity.activity_baseline_date,
      BaselineDuration: activity.activity_baseline_duration,
      BaselineEndDate: calculateEndDate(
        new Date(activity.activity_baseline_date),
        activity.activity_baseline_duration
      ),
      Predecessor: activity.activity_predecessors,
      children: activity.children,
      subtasks: activity.subtasks,
    }));
    // console.log("gantttasks:",gantttasks);
    ///        setTasks(populateGanttSubTasks(activityData))
    const updated_tasks_data = rearrangeData(gantttasks);
    ///        if (tasks.length == 0)
    setTasks(updated_tasks_data);
  };


  const populateListviewTable = (activityData: any[]) => {
    let l_rows_listview = activityData?.map(
      (activity: Activity, index: any) => ({
        // id:activity.id,
        activity_wbs: activity.activity_wbs,
        activity_name: activity.project_code
          ? activity.project_code + ' - ' + activity.activity_name
          : activity.activity_name,
        activity_start_date: activity.activity_start_date,
        activity_end_date: activity.activity_end_date,
        activity_duration: activity.activity_duration,
        assigned_employees: activity.employees,
        assigned_contractors: activity.contractors,
        assigned_color: activity.color,
      })
    );
    setRowsListview(l_rows_listview);
  }


  function rearrangeData(data: GanttTask[]): GanttTask[] {
    const map = new Map<string, GanttTask>(); // Map TaskID to its corresponding Task object

    // Build a map for easy lookup by TaskID
    data.forEach((task) => map.set(task.TaskID, task));

    // Function to recursively add children to the parent's subtasks and update children array
    const addToParent = (parentTaskId: string, childTask: GanttTask) => {
      const parentTask = map.get(parentTaskId);
      if (parentTask) {
        if (!parentTask.subtasks) {
          parentTask.subtasks = [];
        }
        parentTask.subtasks.push(childTask);

        ///        if (!parentTask.children) {
        ///          parentTask.children = [];
        ///        }
        ///        parentTask.children.push(childTask.id);
      }
    };

    // Array to hold top-level tasks
    const topLevelTasks: GanttTask[] = [];

    // Loop through each task
    data.forEach((task) => {
      const parts = task.TaskID?.split("."); // Split TaskID into levels
      if (!parts || parts.length === 0) return; // Skip if TaskID is not valid

      if (parts.length === 1) {
        // If there's only one part, it's a top-level task
        topLevelTasks.push(task);
      } else {
        // Get the immediate parent TaskID
        const parentTaskId = parts.slice(0, -1).join(".");
        addToParent(parentTaskId, task);
      }
    });

    return topLevelTasks;
  }

  const populateTasksDetails = (activityData: any[]) => {
    //To populate the calendar view table
    const tasksEvt: TasksEvent[] = activityData.map((activity: any) => ({
      id: activity.id,
      title: activity.project_code + ' - ' + activity.activity_name,
      start: new Date(activity.activity_start_date),
      end: new Date(activity.activity_end_date),
    }));

    setTaskDetails(tasksEvt);
  };
  /*
    const fetch_emp_contracts_names = async () => {
      //To fetch employees, contractors list from users table
  
      try {
        const status_url = `${BASEURL}/users/emp_contractor_list?orgid=${orgid}`;
        const response = await axios.get(status_url, {
          headers: { Accept: 'application/json' },
        });
  
        const { employees, contractors } = response.data;
        setEmpNames(employees);
        setContractorNames(contractors);
      } catch (error) {
        toast.error("Error in fetching the Employees and Contractors details, contact Admin to resolve this.")
        console.log(error);
      }
    };
  
    function indent() {
      ganttChart.indent();
    }
    function outdent() {
      ganttChart.outdent();
    }
  */
  const onListChange = (event: any) => {
    setSelChartView(event.target.value);
  };

  const validateInput = (inputTask: GanttTask) => {
    //Validate the activity create/modify input fields before submission
    //const wbsPattern = /^[0-9]+(\.[0-9]+)*$/;
    //Validate for TaskID or Wbs id

    if (!inputTask.TaskName) {
      toast.error('Please enter Activity Name');
      return false;
    }
    //    if (!inputTask.StartDate) {
    //      toast.error('Please select Activity Start Date');
    //      return false;
    //   }
    //        if (!inputTask.Duration && Number(inputTask.Duration < 1)) {
    ///        if (!inputTask.Duration ) {
    ///                toast.error("Please enter Duration")
    ///           return false;
    ///       }
    // if (selectedEmployees.length === 0) {
    //     toast.error("Please select Employee Name")
    //     return false;
    // }
    // if (selectedContractors.length === 0) {
    //     toast.error("Please select Contractor Name")
    //     return false;
    // }

    /*
    if (!inputTask.employees) {
      toast.error('Please select Employee Name');
      return false;
    }
    if (!inputTask.contractors) {
      toast.error('Please select Contractor Name');
      return false;
    }
     */

    if (!inputTask.BaselineStartDate) {
      toast.error('Please enter BaselineStartDate');
      return false;
    }
    //    if (!inputTask.BaselineDuration && Number(inputTask.BaselineDuration) < 1) {
    if (Number(inputTask.BaselineDuration) < 1) {
      toast.error('Please enter Baseline Duration');
      return false;
    }

    return true;
  };

  function calculateEndDateStr(startDate: Date, duration: number) {
    // Clone the start date to avoid mutating the original date
    const endDate = new Date(startDate.getTime());
    // Add the duration (in days) to the start date
    endDate.setDate(endDate.getDate() + duration);

    const endDateStr = moment(endDate).format('YYYY-MM-DD');
    return formatDate(endDateStr);
  }

  function calculateEndDate(startDate: Date, duration: number) {
    try {
      // Clone the start date to avoid mutating the original date
      const endDate = new Date(startDate.getTime());
      // Add the duration (in days) to the start date
      endDate.setDate(endDate.getDate() + duration);
      return endDate;
    } catch (error) {
      console.log('Error in calculating the end date', error);
      return startDate;
    }
  }

  const formatDate = (date: string): string => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = ('0' + (d.getMonth() + 1)).slice(-2); // Add leading zero
    const day = ('0' + d.getDate()).slice(-2); // Add leading zero
    return `${year}-${month}-${day}`;
  };

  const sortByWBS = (updatedData: Activity[]) => {
    updatedData.sort((a, b) => {
      const aParts = a.activity_wbs.split('.').map(Number);
      const bParts = b.activity_wbs.split('.').map(Number);

      for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
        const aValue = aParts[i] || 0;
        const bValue = bParts[i] || 0;

        if (aValue !== bValue) {
          return aValue - bValue;
        }
      }
      return 0;
    });
  }


  function findTaskById(taskList: GanttTask[], targetTaskID: string): GanttTask | null {
    for (const task of taskList) {
      if (task.TaskID === targetTaskID) {
        return task;
      }
      if (task.subtasks) {
        const result = findTaskById(task.subtasks, targetTaskID);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }

  const addSubtask = (newTask: GanttTask, new_activity_id: number) => {
    // Split the TaskID to identify the parent task
    const parts = newTask.TaskID.split('.');
    const parentTaskID = parts.slice(0, -1).join('.');
    const parentTask = findTaskById(tasks, parentTaskID);

    if (parentTask != null) {
      // Initialize subtasks and children arrays if they do not exist
      if (!parentTask?.subtasks) {
        parentTask.subtasks = [];
      }
      if (!parentTask?.children) {
        parentTask.children = [];
      }

      // Store new task id as children in parent task
      parentTask?.children?.push(parseInt(newTask.id + ''));
      // Add the new subtask
      parentTask?.subtasks.push(newTask);

      // Sort the subtasks immediately after adding the new one
      parentTask.subtasks = sortTasksByTaskID(parentTask.subtasks);

      const parent_activity = activityData.find(item => item.activity_wbs === parentTaskID);
      if (parent_activity) {
        // Initialize children array in activity if it does not exist
        if (!parent_activity.children) {
          parent_activity.children = [];
        }
        parent_activity.children.push(new_activity_id);
      }
    }

    // Filter out the old task and ensure the new task is in the tasks state
    let filteredTask = tasks.filter(
      (task: any) => task.TaskID !== newTask.TaskID
    );
    setTasks(filteredTask);
};



 const sortTasksByTaskID = (tasks: GanttTask[]) => {
   return tasks.sort((a, b) => {
       const aParts = a.TaskID.split('.').map(Number);
       const bParts = b.TaskID.split('.').map(Number);
       for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
           if (aParts[i] !== bParts[i]) {
               return aParts[i] - bParts[i];
           }
       }
       return 0; // If TaskIDs are identical
   });
 };

// const sortTasksByTaskID = (tasks: GanttTask[]) => {
//   return tasks.sort((a, b) => {
//       const aParts = a.TaskID.split('.').map(Number);
//       const bParts = b.TaskID.split('.').map(Number);
//       for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
//           const aVal = aParts[i] || 0; // Default to 0 for missing parts
//           const bVal = bParts[i] || 0;
//           if (aVal !== bVal) {
//               return aVal - bVal;
//           }
//       }
//       return 0; // If TaskIDs are identical
//   });
// };



  // function sortTasksByTaskID(tasks: GanttTask[]): GanttTask[] {
  //   // Sort tasks based on TaskID using a natural sort (1, 2, 2.1, 2.2, etc.)
  //   tasks.sort((a, b) => a.TaskID.localeCompare(b.TaskID, undefined, { numeric: true }));
    
  //   // Recursively sort subtasks if they exist
  //   tasks.forEach((task) => {
  //     if (task.subtasks) {
  //       task.subtasks = sortTasksByTaskID(task.subtasks);
  //     }
  //   });
  
  //   return tasks;
  // }
  


  //  const addSubtask = (newTask: GanttTask, new_activity_id: number) => {
  //    // Split the TaskID to identify the parent task
  //    const parts = newTask.TaskID.split('.');
  //    const parentTaskID = parts.slice(0, -1).join('.');
  //    const parentTask = findTaskById(tasks, parentTaskID);

  // if (parentTask != null) {
  //      if (!parentTask?.subtasks) {
  //        parentTask.subtasks = [];
  //      }
  //      if (!parentTask?.children) {
  //        parentTask.children = [];
  //      }

  //      parentTask?.children?.push(parseInt(newTask.id + '')); //store newtask id as children in parent task
  //      parentTask?.subtasks.push(newTask);

  //      const parent_activity = activityData.find(item => item.activity_wbs === parentTaskID);
  //      if (parent_activity) {
  //        // Add the newChildValue to the children array
  //        if (!parent_activity.children) {
  //          parent_activity.children = [];
  //        }
  //        parent_activity.children.push(new_activity_id);
  //      }

  //    }

  //    let filteredTask = tasks.filter(
  //      (task: any) => task.TaskID !== newTask.TaskID
  //    );
  //   filteredTask =  sortTasksByTaskID(filteredTask);
  //    setTasks(filteredTask);
  //  };

  // Modify the addSubtask function to apply sorting
// const addSubtask = (newTask: GanttTask, new_activity_id: number) => {
//   const parts = newTask.TaskID.split('.');
//   const parentTaskID = parts.slice(0, -1).join('.');
//   const parentTask = findTaskById(tasks, parentTaskID);

//   if (parentTask != null) {
//     if (!parentTask.subtasks) {
//       parentTask.subtasks = [];
//     }
//     if (!parentTask.children) {
//       parentTask.children = [];
//     }

//     parentTask.children.push(parseInt(newTask.id + ''));
//     parentTask.subtasks.push(newTask);
//     parentTask.subtasks = sortTasksByTaskID(parentTask.subtasks); // Sort subtasks after adding

//     const parent_activity = activityData.find(item => item.activity_wbs === parentTaskID);
//     if (parent_activity) {
//       if (!parent_activity.children) {
//         parent_activity.children = [];
//       }
//       parent_activity.children.push(new_activity_id);
//     }
//   }

//   // Sort top-level tasks as well and update the state
//   let updatedTasks = sortTasksByTaskID(tasks);
//   setTasks(updatedTasks);
// };
  // const AddIdtoNewTask = (newTask: GanttTask) => {
  //   let filteredTask = tasks.filter(
  //     (task: any) => task.TaskID !== newTask.TaskID
  //   );
  //   filteredTask.push(newTask);
  //   setTasks(filteredTask);

  //   // Add the new task at the end
  //   //     setTasks(tasks.map(task =>
  //   //          task.TaskID === newTask.TaskID ? newTask : task
  //   //    ));
  // };

  // Update AddIdtoNewTask to apply sorting for top-level tasks
const AddIdtoNewTask = (newTask: GanttTask) => {
  let filteredTask = tasks.filter((task) => task.TaskID !== newTask.TaskID);
  filteredTask.push(newTask);
  filteredTask = sortTasksByTaskID(filteredTask); // Sort tasks after adding new task
  setTasks(filteredTask);
  // const sortedTasks = sortTasksByTaskID(filteredTask);
  //   setTasks(sortedTasks);
};
  


  const addOrUpdateTask = async (id: number, newtask: any) => {
    //To save the new activity or update activity if id is not zero.
    setIsLoading(true);
    const payload = {
      id: id,
      project_id: selProjectId,
      project_code: arg_projectcode ? arg_projectcode : '',
      activity_wbs: newtask.TaskID,
      //      activity_name: newtask.TaskName,
      activity_name: newtask.TaskName.startsWith(arg_projectcode)
        ? newtask.TaskName.replace(new RegExp(`^${arg_projectcode}\\s*-?\\s*`), '')
        : newtask.TaskName,

      color: newtask.color,
      activity_description: newtask.Description,
      activity_type: 'task',
      activity_progress: newtask.Progress,
      employees: newtask.employees,
      contractors: newtask.contractors,
      activity_start_date: formatDate(newtask.StartDate),
      activity_end_date: calculateEndDateStr(newtask.StartDate, newtask.Duration),
      activity_duration: newtask.Duration,
      activity_baseline_date: moment(newtask.BaselineStartDate).format('YYYY-MM-DD'),
      activity_baseline_duration: Number(newtask.BaselineDuration),
      activity_predecessors: newtask.Predecessor,
      children: [],
      children_record:newtask.childRecords,

    };

    try {
      //save data into db
      // If an activity is selected, update the activity using its ID, otherwise create new one.
      const create_url = BASEURL + '/activity/create/';
      let response = await axios.post(create_url, payload, {
        ///        headers: { 'Content-Type': 'multipart/form-data' },
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.data.success) {
        toast.error(response.data.message);
        return;
      }

      let new_activity_id = parseInt(response?.data.activitydata_id);
      const startDate = new Date(payload.activity_start_date);
      let enddate = calculateEndDate(startDate, payload.activity_duration);

      const newTaskGantt: GanttTask = {
        id: new_activity_id,
        TaskID: payload.activity_wbs,
        ///        TaskName: arg_projectcode
        ///          ? arg_projectcode + ' - ' + payload.activity_name
        ///          : payload.activity_name,
        TaskName: arg_projectcode && !payload.activity_name.startsWith(arg_projectcode)
          ? arg_projectcode + ' - ' + payload.activity_name
          : payload.activity_name,

        Description: payload.activity_description,
        StartDate: new Date(payload.activity_start_date),
        color: payload.color,
        Progress: Number(payload.activity_progress),
        Duration: payload.activity_duration,
        employees: payload.employees,
        contractors: payload.contractors,
        BaselineStartDate: new Date(newtask.BaselineStartDate),
        BaselineDuration: payload.activity_baseline_duration,
        BaselineEndDate: calculateEndDate(
          newtask.BaselineStartDate,
          payload.activity_baseline_duration
        ),
        Predecessor: payload.activity_predecessors,
      };

      if (id === 0) {
        if (newTaskGantt.TaskID.indexOf('.') !== -1)
          addSubtask(newTaskGantt, new_activity_id);
        //Add new task as subtask and remove from main list
        //Update the new id and project code to the new task created in gantt data tasks
        else
          AddIdtoNewTask(newTaskGantt);

        ////const sorted_tasks = sortTasks();
        ////setTasks(sorted_tasks);

        //Update calendar details with new activity
        const updatedDetails: TasksEvent = {
          id: new_activity_id,
          title: payload.activity_name,
          start: startDate,
          end: enddate,
        };

        payload.id = new_activity_id;
        setTaskDetails((prevTasksEvt) => [...prevTasksEvt, updatedDetails]);
        setActivityData([...activityData, payload]);
      } else {
        //Update the modifed task in gantt data tasks
        //updateTask(newTasksGantt)

        // Update existing activity
        setActivityData(
          activityData.map((activity) =>
            activity.id === id ? payload : activity
          )
        );

        if (taskDetails != null) {
          const updatedDetails = taskDetails.map((task) => {
            if (task.id === id) {
              return {
                ...task,
                title: payload.activity_name,
                start: startDate,
                end: enddate,
              };
            }
            return task;
          });
          setTaskDetails(updatedDetails);
        }
      }
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : String(error);
      if(id==0)
        // toast.error("Error in creating new task, please contact helpdesk: " + errorMessage);
      toast.error("Something went wrong while creating new task.Please contact support");
      else
        toast.error("Something went wrong while updating task.Please contact support");
      console.error('Error in creating or update task:', errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  function getTaskIds(task: GanttTask): number[] {
    //To get id, ids of subtasks recursively
    let ids: number[] = [task.id];
    task.subtasks?.forEach((subtask) => {
      ids = ids.concat(getTaskIds(subtask));
    });

    return ids;
  }


  function joinUptoLevel(counter: number[], level: number): string {
    // Slice the array up to the given level and join the values with a dot
    return counter.slice(0, level).join('.');
  }


  function reorderWBS1() {  //simplified form of reorderwbs   
    let counter = [0]; // Only initialize first level; other levels will be added dynamically as needed.
    let prevDotCount = -1;

    activityData.forEach((activity) => {
      let wbsParts = activity.activity_wbs.split('.');
      let wbs_dotCount = wbsParts.length - 1;
      let updatedWBS = '';

      if (counter.length <= wbs_dotCount) {       // Extend counter if deeper levels are present
        counter[wbs_dotCount] = 1;
      }

      if (wbs_dotCount === 0) { // For main task, increase first level counter and reset sub-levels
        counter[0]++;
        counter = counter.map((value, index) => (index === 0 ? value : 1));
        updatedWBS = `${counter[0]}`;
        prevDotCount = -1;
      } else {
        if (prevDotCount >= wbs_dotCount) {
          // If moving to the same or higher level, increment the respective counter
          counter[wbs_dotCount]++;
        } else if (prevDotCount < wbs_dotCount) {
          // If going deeper into sub-levels, keep counters as they are
          counter[wbs_dotCount] = 1;
        }
        updatedWBS = joinUptoLevel(counter, wbs_dotCount + 1);
        prevDotCount = wbs_dotCount;
      }

      activity.activity_wbs = updatedWBS;
    });
  }


  // function reorderWBS() {   //To reorder the WBS in sequence order after delete or if some WBS missed

  //   let counter = [0, 1, 1, 1, 1, 1, 1, 1, 1, 1]

  //   let prevDotCount = -1;
  //   activityData.forEach((activity) => {
  //     let w1 = activity.activity_wbs
  //     let wbs_dotCount = w1.split('.').length - 1;
  //     let updatedWBS = '1';
  //     if (wbs_dotCount === 0) {  //For main task increase first level counter and set others to default
  //       counter[0] = counter[0] + 1
  //       counter = counter.map((value, index) => index === 0 ? value : 1);
  //       updatedWBS = counter[wbs_dotCount] + '';
  //       prevDotCount = -1;
  //     }
  //     else {
  //       if (prevDotCount >= wbs_dotCount) //If WBS is changed from 1.1.1 to 1.1.2 or to 1.2 increase counter
  //         counter[wbs_dotCount] = counter[wbs_dotCount] + 1
  //       updatedWBS = joinUptoLevel(counter, wbs_dotCount + 1);
  //       prevDotCount = wbs_dotCount;
  //     }
  //     activity.activity_wbs = updatedWBS;

  //   })

  // }


  function reorderWBS() {
    // Reset the counter array for tracking each WBS level.
    let counter = [0, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    let prevDotCount = -1;
  
    activityData.forEach((activity) => {
      const wbsDotCount = activity.activity_wbs.split('.').length - 1;
  
      // Reset counters for a new main task
      if (wbsDotCount === 0) {
        counter[0]++;
        counter = counter.map((value, index) => (index === 0 ? value : 1));
        prevDotCount = -1;
      } else {
        // Reset counter if moving to a new parent task level
        if (prevDotCount >= wbsDotCount) {
          counter[wbsDotCount]++;
        } else {
          counter[wbsDotCount] = 1; // Start subtask numbering from 1 at each new level
        }
      }
  
      // Generate the WBS by joining the counters up to the current level
      activity.activity_wbs = counter.slice(0, wbsDotCount + 1).join('.');
      prevDotCount = wbsDotCount;
    });
  }
  


  /*
    function reorderWBS_Old(data: Activity[]): Activity[] {
  
      // Helper function to assign WBS numbers
      function assignWBS(tasks: Activity[], parentWBS: string = '', counters: number[] = []): void {
        // Sort tasks by their current WBS values
        
              tasks.sort((a, b) => {
                const aWBS = a.activity_wbs.split('.').map(Number);
                const bWBS = b.activity_wbs.split('.').map(Number);
                for (let i = 0; i < Math.max(aWBS.length, bWBS.length); i++) {
                  if ((aWBS[i] || 0) !== (bWBS[i] || 0)) {
                    return (aWBS[i] || 0) - (bWBS[i] || 0);
                  }
                }
                return 0;
              });
        
        let counter = 1;
  
        tasks.forEach((task) => {
          // Construct new WBS number
          let newWBS = parentWBS ? `${parentWBS}.${counter}` : `${counter}`;
          task.activity_wbs = newWBS;
          // Increment the counter
  
          // Recursively assign WBS numbers to child tasks
          const children = task.children
            ?.map(childId => data.find(t => t.id === childId))
            .filter((child): child is Activity => Boolean(child));
  
          if (children && children.length > 0) {
            assignWBS(children, newWBS);
          }
          counter++;
  
        });
      }
  
      // Find root tasks (tasks with no parent WBS or top-level WBS)
      const rootTasks = data.filter(task => task.activity_wbs.split('.').length === 1);
      assignWBS(rootTasks);
  
      return data;
    }
  */

  // Function to remove the task from children and subtasks
  const removeChild = (taskdata: GanttTask, delid: number) => {
    // Remove from children array
    if (taskdata.children) {
      taskdata.children = taskdata.children.filter((childId) => childId !== delid);
    }

    // Remove from subtasks array
    if (taskdata.subtasks) {
      taskdata.subtasks = taskdata.subtasks.filter((subtask) => subtask.id !== delid);
    }
  };


  // const handleDeleteActivity = async (selTask: GanttTask) => {

  //   //Delete the selected activity and its sub tasks
  //   try {
  //     setIsLoading(true)
  //     const actid = selTask?.id;  //selected activity id
  //     const selTaskID = selTask?.TaskID; //selected TaskID 


  //     //Step1 - Find the lists of ids and subtask ids to delete

  //     //      const delTask = tasks.filter((task: GanttTask) => task.id === actid);
  //     const actids = getTaskIds(selTask);

  //     //Step2 - Delele all the above ids
  //     const url_delete = BASEURL + `/activity/delete/`
  //     let response = await axios.delete(url_delete, { data: { actids } });

  //     //Step3 - Check the result of the task deletion in DB
  //     if (response.status !== 204) {
  //       toast.error("Error in deleting the selected activity.")
  //       return
  //     }

  //     //Step4 - Find parent task and Remove the id from children array of the parent of the deleted task
  //     let updatedTasks = (tasks.filter((task: any) => task.TaskID !== selTaskID));

  //     let parentTask: GanttTask;
  //     if (selTaskID.includes('.')) {
  //       const parts = selTaskID.split('.');
  //       const parentTaskID = parts.slice(0, -1).join('.');

  //       parentTask = (updatedTasks.filter((task: any) => task.TaskID === parentTaskID))[0];
  //       removeChild(parentTask, actid)

  //       ///                orderded_task =  reorderSubtaskIDs(parentTask, selTaskID)
  //     }
  //     else {
  //       ///               orderded_task1 =  reorderMainTaskIDs(updatedTasks, selTaskID)
  //       ///                setTasks(orderded_task1) 
  //     }

  //     //Step5 - Reorder the TaskIDs in parent's subtasks tasksids - from 1.1, 1.3, 1.4 to 1.1, 1.2, 1.3


  //     ///updatedTasks = updatedTasks.map(task => task.TaskID === parentTask.TaskID ? parentTask : task);

  //     //Step6 - Remove the children records of selectedtask in list view
  //     let filteredData = activityData.filter((activity: any) => !actids.includes(activity.id));
  //     setActivityData(filteredData)

  //     //Step7 - Remove the above ids records in calendar view
  //     ///        let filteredTaskDetails = taskDetails.filter((task: any) => !actids.includes(task.id));
  //     ///        setTaskDetails(filteredTaskDetails);

  //   } catch (error) {
  //     console.log("error", error)
  //     toast.error('Error in deleting the selected Activity '+ error);
  //   }
  //   finally {
  //     setIsLoading(false)
  //   }

  // }


  const handleDeleteActivity = async (selTask: GanttTask) => {
    try {
      setIsLoading(true);
      const actid = selTask?.id;
      const selTaskID = selTask?.TaskID;
  
      // Step 1 - Find the lists of ids and subtask ids to delete
      const actids = getTaskIds(selTask);
  
      // Step 2 - Delete all the above ids from the backend
      const url_delete = BASEURL + `/activity/delete/`;
      let response = await axios.delete(url_delete, { data: { actids } });
  
      // Step 3 - Check the result of the task deletion in DB
      if (response.status !== 204) {
        toast.error("Something went wrong while deleting the selected activity. Please contact support");
        return;
      }
  
      // Step 4 - Remove the deleted task and update its parent's children array
      let updatedTasks = tasks.filter((task: any) => task.TaskID !== selTaskID);
  
      if (selTaskID.includes('.')) {
        const parts = selTaskID.split('.');
        const parentTaskID = parts.slice(0, -1).join('.');
  
        // Check if the parent task exists before updating it
        const parentTask = updatedTasks.find((task: any) => task.TaskID === parentTaskID);
        
        if (parentTask) {
          // Safely remove the child from the parent's children array
          removeChild(parentTask, actid);
        }
      }
  
      // Step 5 - Reorder TaskIDs if necessary
      // (e.g., reorderSubtaskIDs if you have a specific function for reordering)
  
      // Step 6 - Update activity data and list view
      let filteredData = activityData.filter((activity: any) => !actids.includes(activity.id));
      setActivityData(filteredData);
  
      // Additional cleanup if necessary (e.g., calendar view)
    } catch (error) {
      // console.log("Error:", error);
      // toast.error("Error in deleting the selected Activity ");
      toast.error("Something went wrong while deleting the selected activity. Please contact support");
    } finally {
      setIsLoading(false);
    }
  };
  
useEffect(() => {
    // console.log("Notify button disabled state changed:", isNotifyButtonDisabled);
}, [isNotifyButtonDisabled]);

const selectedEmployeesRef = useRef(selectedEmployees);
const selectedContractorsRef = useRef(selectedContractors);

useEffect(() => {
    selectedEmployeesRef.current = selectedEmployees;
    selectedContractorsRef.current = selectedContractors;
}, [selectedEmployees, selectedContractors]);
  // Function to handle notification logic
const notifyUserForSingleActivity = async (args: any) => {
  try {
    const notifyPayload = {
     TaskID: args.TaskID,
       TaskName: args.TaskName,
       Duration: args.Duration,
       StartDate: args.StartDate,
       BaselineStartDate: args.BaselineStartDate,
       BaselineDuration: args.BaselineDuration,
       contractors:args.Contractors ,
       employees: args.Employees,
       Progress: args.Progress,
       project_id: selProjectId ,
    }

    // Send data to the backend using Axios
    const response = await axios.post(BASEURL + '/notify-user-singleperson/', {notifyPayload});

    if (response.status === 200) {
      toast.success('Users notification sent successfully');
    } else {
      toast.error('Failed to send notification to users');
    }
  } catch (error: any) {
    toast.error((error as Error).message || 'Something went wrong');
  } 
};


const gatherFormData = (args: any) => {
  const form = document.querySelector('.e-gantt-dialog') as any;
  if (!form) return {}; // Handle null case
  const taskId = form.querySelector('[name="TaskID"]')?.value || '';
  const taskName = form.querySelector('[name="TaskName"]')?.value || '';
  const startDate = form.querySelector('[name="StartDate"]')?.value || '';
  const duration = form.querySelector('[name="Duration"]')?.value || '';
  const baselineDate = form.querySelector('[name="BaselineStartDate"]')?.value || '';
  const baselineduration = form.querySelector('[name="BaselineDuration"]')?.value || '';
  const progress = form.querySelector('[name="Progress"]')?.value || '';
// // Use the refs for selected employees and contractors
//   const selectedEmployees2 = selectedEmployeesRef.current;
//   const selectedContractors2 = selectedContractorsRef.current;

  // Use refs or state to get selected employees and contractors
  const selectedEmployees2 = selectedEmployeesRef.current || selectedEmployees;
  const selectedContractors2 = selectedContractorsRef.current || selectedContractors;

  return {
    TaskID:taskId,
    TaskName: taskName,
    StartDate: startDate,
    Duration: duration,
    BaselineStartDate: baselineDate,
    BaselineDuration: baselineduration,
    Employees:selectedEmployees2 ,
    Contractors: selectedContractors2,
    Progress: progress,
    
  };
};

function calculatebaselineEndDateStr(startDate: Date, duration: number): string {
  // Clone the start date to avoid mutating the original date
  const endDate = new Date(startDate.getTime());
  // Add the duration (in days) to the start date
  endDate.setDate(endDate.getDate() + duration);

  // Format and return the calculated end date
  return moment(endDate).format('YYYY-MM-DD');
}


  const actionComplete = async (args: any) => {

    if (args.requestType === 'add') {    //Add Task
      const newTask = args.data;
      // console.log("newTask1:",newTask);
      addOrUpdateTask(0, newTask)
      if (arg_projectcode) {
        let tn = args.data.TaskName;
        args.data.taskData.TaskName = arg_projectcode + ' - ' + tn;
        args.data.TaskName = arg_projectcode + ' - ' + tn;
        args.data.ganttProperties.taskName = arg_projectcode + ' - ' + tn;
      }
    }
    else if (args.requestType === 'save') {  //Update Task
      const newTask = args.data;
      // console.log("newTask:",newTask);
      const id = newTask?.taskData?.id;
      await addOrUpdateTask(id, newTask);
      if (arg_projectcode) {
        let tn = args.data.TaskName;
        if (!args.data.taskData.TaskName.startsWith(arg_projectcode))
          args.data.taskData.TaskName = arg_projectcode + ' - ' + tn;
        if (!args.data.TaskName.startsWith(arg_projectcode))
          args.data.TaskName = arg_projectcode + ' - ' + tn;
        if (!args.data.ganttProperties.taskName.startsWith(arg_projectcode))
          args.data.ganttProperties.taskName = arg_projectcode + ' - ' + tn;
      }

    }
    else if (args.requestType === 'delete') { //Delete Task
      //const newTask = args.data;
      //        const id = newTask[0]?.taskData?.id;
      //        const taskid = newTask[0]?.taskData?.TaskID;
      //        handleDeleteActivity(newTask[0].taskData)

      //Reorder the task number for the deleted rows
      //let deltask = deleteTask(tasks, taskid);
      //updateTaskIDs(deltask);

    }
  }

//   // Function to sort tasks by TaskID
// const sortTasksByTaskID = (taskList:any) => {
//   return taskList.sort((a:any, b:any) => {
//     const aParts = a.TaskID.split('.').map(Number);
//     const bParts = b.TaskID.split('.').map(Number);

//     for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
//       const aPart = aParts[i] || 0;
//       const bPart = bParts[i] || 0;
//       if (aPart !== bPart) return aPart - bPart;
//     }
//     return 0;
//   });
// };



  const actionBegin = async (args: any) => {

    if (args.action === 'beforeAdd' || args.requestType === 'beforeSave') { // Handle add task
      const newTask = args.data;
      // Project end date
      const projectMessageEndDate = new Date(project_enddate);
  
      // Task end date validation
      const taskEndDate = new Date(newTask?.ganttProperties?.endDate);
      if (taskEndDate > projectMessageEndDate) {
        args.cancel = true; // Prevent the dialog from closing
        toast.error("Please select the date before the project enddate.");
        return;
      }
      const baselineStartDate = new Date(newTask?.BaselineStartDate);
    const baselineDuration = newTask?.BaselineDuration;
    const project_message_enddate = new Date(project_enddate);

    if (baselineStartDate && baselineDuration) {
      // Calculate BaselineEndDate
      const baselineEndDateStr = calculatebaselineEndDateStr(baselineStartDate, baselineDuration);
      const baselineEndDate = new Date(baselineEndDateStr);

      // Validate BaselineEndDate
      if (baselineEndDate > project_message_enddate) {
        // Show toast message
        args.cancel = true; // Prevent the dialog from closing
        toast.error("Please select the baseline enddate before the project enddate.");
        return; // Stop further processing
      }
    }
    }
    
    if (
      args.requestType === 'beforeOpenAddDialog' ||
      args.requestType === 'beforeOpenEditDialog' ||
      args.requestType === 'beforeDelete'
    ) {

       //if (!is_admin && scheduleAccess.toLowerCase() !== 'owner') {
         // Validate for Edit access
      //   toast.info('Sorry, access denied to add or update the task.');
      //   args.cancel = true;
      //   return;
      // }
      if (!editMode) {
        //Allow to add/edit in edit mode only
        // toast.info('You are in View mode. Please click Edit button to change to Edit mode.');
        args.cancel = true;
        return;
      }

      if (args.dialogModel) {
        // Set dialog height and set dialog background color using a CSS class
        args.dialogModel.cssClass = 'custom-dialog';
        // Customize the button color
        args.dialogModel.buttons.forEach((button: any) => {
          button.buttonModel.cssClass = 'custom-button';
        });

        args.dialogModel.buttons.push({
          buttonModel: {
            content: 'Notify Users',
            cssClass: isNotifyButtonDisabled ? 'custom-notify-button-disabled' : 'custom-notify-button',
            isPrimary: false,
            disabled: isNotifyButtonDisabled,
          },
          click:async  () => {
          
    // Capture the current form data including custom fields
    setIsNotifyButtonDisabled(true); // Disable the button
    // console.log("Before disable:", isNotifyButtonDisabled);
    const formData = gatherFormData(args); 
    try {
      await notifyUserForSingleActivity(formData); // Send notification
  } catch (error) {
      console.error("Error notifying user:", error);
  } finally {
    console.log("Before re-enable:", isNotifyButtonDisabled);
    setIsNotifyButtonDisabled(false); // Re-enable the button after notification attempt
      console.log("After re-enable:", isNotifyButtonDisabled);
      setTimeout(() => {
        console.log("After re-enable:", isNotifyButtonDisabled);
      }, 0);
    }
  },
        });
      }
      if (args.rowData) {
        if (args.requestType === 'beforeOpenAddDialog') {
          args.rowData.Description = 'Description';
          // args.rowData.BaselineStartDate = new Date();
          // args.rowData.StartDate = new Date(); // Set default Description
          args.rowData.BaselineStartDate = project_startdate ? new Date(project_startdate) : new Date();
          // args.rowData.StartDate = new Date(); // Set default Description
          args.rowData.StartDate = project_startdate ? project_startdate : new Date();
          args.rowData.color = 'Purple';
          args.rowData.BaselineDuration = 1;
          // args.rowData.contractors = 'Default Contractors'; // Set default Description
          // args.rowData.employees = 'Default Employees';
        }
      }
    }

    if (args.requestType === 'beforeOpenAddDialog') {
      if (ganttChart && ganttChart.editSettings != null)
        ganttChart.editSettings.newRowPosition = 'Top';
      //    ganttChart.editSettings.newRowPosition = 'Child';

     args.rowData.StartDate = project_startdate ? new Date(project_startdate) : new Date();
      setTimeout(() => {
        const datePickerElement = document.querySelector('.e-datepicker') as any; // Type casting to bypass TypeScript error
        if (datePickerElement && datePickerElement.ej2_instances) {
          const datePickerInstance = datePickerElement.ej2_instances[0];
          datePickerInstance.min = new Date(project_startdate ? project_startdate : new Date()); // Set the minimum date here
          if (project_enddate) {
            datePickerInstance.max = new Date(project_enddate); // Set maximum date
          }
        }
         // Set minimum for BaselineStartDate date picker
      const baselineDatePickerElement = document.querySelectorAll('.e-datepicker')[1] as any; // Assuming the second datepicker is BaselineStartDate
      if (baselineDatePickerElement && baselineDatePickerElement.ej2_instances) {
        const baselineDatePickerInstance = baselineDatePickerElement.ej2_instances[0];
        baselineDatePickerInstance.min = new Date(project_startdate ? project_startdate : new Date());
        if (project_enddate) {
          baselineDatePickerInstance.max = new Date(project_enddate); // Set maximum date
        }
      }
      }, 0);
    } else if (args.requestType === 'beforeAdd') {
      let ret = validateInput(args.newTaskData);
      if (!ret) {
        args.cancel = true;
        return;
      }

      let newid = args.newTaskData.TaskID;

      if (ganttChart && ganttChart.editSettings != null)
        if (newid.includes('.')) {
          let parent = newid.replace(/\.\d+$/, '');  //remove last digit
          const wbsParentExists = activityData.some(activity => activity.activity_wbs === parent);
          if (!wbsParentExists) {
            toast.error("Parent task for the given WBS does not exist, please check the WBS.")
            args.cancel = true;
            return;
          }
          ganttChart.editSettings.newRowPosition = 'Child';

        }
        else
          ganttChart.editSettings.newRowPosition = 'Top';
    } else if (args.requestType === 'beforeOpenEditDialog') {
      // console.log("Row Data in Edit Dialog:", args.rowData); // Log the entire row data
      if (args.rowData) {
        // Same logic for setting min dates for the edit dialog
        setTimeout(() => {
          const datePickers = document.querySelectorAll('.e-datepicker') as NodeListOf<any>;
          if (datePickers.length > 0) {
            // StartDate DatePicker
            const startDatePicker = datePickers[0];
            if (startDatePicker && startDatePicker.ej2_instances) {
              const startDateInstance = startDatePicker.ej2_instances[0];
              startDateInstance.min = new Date(project_startdate ? project_startdate : new Date());
              if (project_enddate) {
                startDateInstance.max = new Date(project_enddate); // Set maximum date
              }
              
            }
  
            // BaselineStartDate DatePicker
            const baselineDatePicker = datePickers[1];
            if (baselineDatePicker && baselineDatePicker.ej2_instances) {
              const baselineDateInstance = baselineDatePicker.ej2_instances[0];
              baselineDateInstance.min = new Date(project_startdate ? project_startdate : new Date());
              if (project_enddate) {
                baselineDateInstance.max = new Date(project_enddate); // Set maximum date
              }
            }
          }
        }, 0);
      }
      let tname = args.rowData.TaskName;
      if (tname.includes(' - ')) {
        let parts = tname.split('-');
        args.rowData.TaskName = parts[1].trim();
      }
       // Set selected employees and contractors for edit
  const taskEmployees = args.rowData.employees
    ? Array.isArray(args.rowData.employees)
      ? args.rowData.employees
      : args.rowData.employees.split(',') // Convert comma-separated string to array
    : [];
  
  const taskContractors = args.rowData.contractors
    ? Array.isArray(args.rowData.contractors)
      ? args.rowData.contractors
      : args.rowData.contractors.split(',') // Convert comma-separated string to array
    : [];

  // console.log("taskEmployees (edited):", taskEmployees);
  // console.log("taskContractors (edited):", taskContractors);
  // Update selected employees and contractors in state
  setSelectedEmployees(taskEmployees);
  setSelectedContractors(taskContractors);
    } else if (args.requestType === 'beforeSave') {
      let ret = validateInput(args.modifiedTaskData[0]);
      if (!ret) {
        args.cancel = true;
        return;
      }
      if (args.data.BaselineDuration != null)
        {

            const baselineStartDate = new Date(args.data.BaselineStartDate); // Convert to Date object    
            const baselineDuration = args.data.BaselineDuration; // Duration in days

            // Calculate new BaselineEndDate
            const newBaselineEndDate = new Date(baselineStartDate);
            newBaselineEndDate.setDate(baselineStartDate.getDate() + baselineDuration); 

            // Update the BaselineEndDate
            args.data.BaselineEndDate = newBaselineEndDate;
            args.data.ganttProperties.baselineEndDate = newBaselineEndDate;
          }
    }

    if (args.requestType === 'beforeDelete') {
      //confirm the user before deleting the task
      const confirm = window.confirm(
        'Are you sure you want to delete the selected task?\nThis action cannot be undone.'
      );
      if (confirm) {
        handleDeleteActivity(args.data[0].taskData);
      } else {
        args.cancel = true;
        return;
      }
    }
  };

  const toolbarClick = async (args: any) => {
    //   if (args.item.id && args.item.id.includes('delete')) {
    //       await setSelectedTaskIdForDelete(selectedTaskIdForDelete ? selectedTaskIdForDelete : null);
    //            await deleteSelectedTask();
    //   }
    if (args.item.text === 'Critical Path') {
      setIsCriticalPathEnabled((prev) => !prev);// Toggle critical path visibility
      setGanttKey((prev) => prev + 1); // Force re-render of Gantt component
       
    }
    if (ganttChart) {
      if (args.item.text === 'Pdf export') {
        ganttChart.pdfExport();

      }
      if (args.item.text === 'GanttExport_excelexport') {
        ganttChart.excelExport();
      }
      if (args.item.text === 'Indent') {
        ganttChart.indent();
      }
      if (args.item.text === 'Outdent') {
        ganttChart.outdent();
      }
    }
   

    if (args.item.text === 'Reorder WBS') {
      if (editMode) {
        ///        const updatedData = reorderWBS(activityData);
        sortByWBS(activityData)
        reorderWBS();
        populateGanttTasks(activityData)
        populateListviewTable(activityData);
        saveAllActivities();
      }
      else {
        // toast.info("You are in View mode. Please click Edit button to change to Edit mode.")
        args.cancel = true;
        return
      }
    }

    if (args.item.text === 'Change WBS') {
      // console.log("tasks", tasks)
      // console.log("activity data", activityData)
      if (editMode) {
        setOpenWBSDialog(true);
      }
      else {
        // toast.info("You are in View mode. Please click Edit button to change to Edit mode.")
        args.cancel = true;
        return
      }
    }


  };

  // Function to send updated activityData to Django backend
  // const saveAllActivities = async () => {
  //   try {
  //     // Preprocess activityData to normalize employees and contractors
  //   const normalizedData = activityData.map((activity) => ({
  //     ...activity,
  //     employees: Array.isArray(activity.employees)
  //       ? activity.employees.join(',')
  //       : activity.employees.replace(/[\[\]'"]/g, ''), // Handle cases where array-like strings exist
  //     contractors: Array.isArray(activity.contractors)
  //       ? activity.contractors.join(',')
  //       : activity.contractors.replace(/[\[\]'"]/g, ''), // Handle cases where array-like strings exist
  //   }));

  //     const update_url = BASEURL + '/activity/update/';
  //     console.log("activityData:",normalizedData);
  //     const response = await axios.put(update_url, normalizedData, {
  //       headers: { 'Content-Type': 'application/json' },
  //     });

  //     if (response.status !== 200) {
  //       // toast.error('Error in updating the activity details.');
  //       toast.error("Something went wrong while updating the activity details. Please contact support.")
  //     }
  //   } catch (error) {
  //     // Handle error
  //     toast.error("Something went wrong while updating the activity details. Please contact support")
  //     console.log('Error in updating activity details.' + error);
  //   }
  // };

  const saveAllActivities = async () => {
    try {
      // Preprocess activityData to normalize employees, contractors, and remove duplicate predecessors
      const normalizedData = activityData.map((activity) => {
        if (activity.activity_predecessors && activity.activity_wbs) {
          // Split predecessors into an array and normalize by trimming spaces
          const predecessorsArray = activity.activity_predecessors
            .split(',')
            .map((pred) => pred.trim());
  
          // Remove predecessors that match the activity_wbs
          const filteredPredecessors = predecessorsArray.filter(
            (pred) => !pred.startsWith(activity.activity_wbs) // Match with prefix
          );
  
          // Update activity_predecessors with filtered values
          activity.activity_predecessors = filteredPredecessors.join(', ');
        }
  
        return {
          ...activity,
          employees: Array.isArray(activity.employees)
            ? activity.employees.join(',')
            : activity.employees.replace(/[\[\]'"]/g, ''), // Handle cases where array-like strings exist
          contractors: Array.isArray(activity.contractors)
            ? activity.contractors.join(',')
            : activity.contractors.replace(/[\[\]'"]/g, ''), // Handle cases where array-like strings exist
        };
      });
  
      const update_url = BASEURL + '/activity/update/';
      // console.log('Processed activityData:', normalizedData);
  
      // Send the processed data to the backend
      const response = await axios.put(update_url, normalizedData, {
        headers: { 'Content-Type': 'application/json' },
      });
  
      if (response.status !== 200) {
        toast.error('Something went wrong while updating the activity details. Please contact support.');
      }
    } catch (error) {
      toast.error('Something went wrong while updating the activity details. Please contact support');
      console.log('Error in updating activity details:', error);
    }
  };
  



  const handleChangeWBS = () => { //change wbs number
    let src_dotCount = sourceWBS.split('.').length - 1;
    let target_dotCount = targetWBS.split('.').length - 1;

    if (src_dotCount > 0 && target_dotCount === 0) {
      toast.error("Sub task can not be moved to Main task.")
      return
    }

    if (sourceWBS === targetWBS) {
      setOpenWBSDialog(false);
      return
    }

    const updatedData = changeWbsValues(sourceWBS, targetWBS);
    sortByWBS(updatedData)
    populateGanttTasks(updatedData)  //After change wbs update tasks in gantt chart
    populateListviewTable(updatedData);   //After change wbs updaate list view
    saveAllActivities();

    setOpenWBSDialog(false);
  }

  const handleSourceWBSChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSourceWBS(event.target.value);
  };

  const handleTargetWBSChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTargetWBS(event.target.value);
  };

  function changeWbsValues(sourceWbs_str: string, targetWbs_str: string): Activity[] {
    const sourceWbs = parseInt(sourceWbs_str)
    const targetWbs = parseInt(targetWbs_str)

    let src_dotCount = sourceWbs_str.split('.').length - 1;
    let target_dotCount = targetWbs_str.split('.').length - 1;
    let source_first_str = sourceWbs_str.replace(/\.\d+$/, '');  //remove last
    let target_first_str = targetWbs_str.replace(/\.\d+$/, '');

    let source_last = parseInt(sourceWbs_str.slice(sourceWbs_str.lastIndexOf('.') + 1));
    let target_last = parseInt(targetWbs_str.slice(targetWbs_str.lastIndexOf('.') + 1));
    let source_id = activityData.find(item => item.activity_wbs === sourceWbs_str)?.id;

    //   if (src_dotCount === 0 && target_dotCount === 0 && source_first_str === target_first_str) {  //changing from 2 to 4 or 4 to 2 ie no dots
    if (src_dotCount === 0 && target_dotCount === 0 && source_first_str !== target_first_str) {  //changing from 2 to 4 or 4 to 2 ie no dots

      activityData.forEach(activity => {
        const wbs_parts = activity.activity_wbs.split('.')
        const wbs_main = parseInt(wbs_parts[0]);

        if (sourceWbs > targetWbs) { //6 to 2
          if (wbs_main >= targetWbs && wbs_main < sourceWbs) {
            activity.activity_wbs = activity.activity_wbs.replace(/\d+/, (wbs_main + 1).toString());
          } else if (wbs_parts[0] === source_first_str) {
            //activity.activity_wbs = targetWbs_str;
            activity.activity_wbs = activity.activity_wbs.replace(/\d+/, targetWbs_str);
          }
        }
        else {
          if (wbs_main <= targetWbs && wbs_main > sourceWbs) {
            activity.activity_wbs = activity.activity_wbs.replace(/\d+/, (wbs_main - 1).toString());
          }
          else if (wbs_parts[0] === sourceWbs_str) {
            //activity.activity_wbs = targetWbs_str;
            activity.activity_wbs = activity.activity_wbs.replace(/\d+/, targetWbs_str);
          }
        }

      });
    }
    else if (src_dotCount === target_dotCount && source_first_str === target_first_str) {  //changing from 2 to 4 or 4 to 2 ie no dots

      activityData.forEach(activity => {
        const wbs_parts = activity.activity_wbs.split('.')
        const wbs_last = parseInt(wbs_parts[wbs_parts.length - 1]);
        let wbs_first_str = activity.activity_wbs.replace(/\.\d+$/, '');
        let wbs_dotCount = activity.activity_wbs.split('.').length - 1;

        if (src_dotCount === wbs_dotCount && wbs_first_str === source_first_str) {
          if (source_last > target_last) { //5.4 to 5.2
            if (wbs_last >= target_last && wbs_last < source_last) {
              activity.activity_wbs = wbs_first_str + '.' + (wbs_last + 1).toString();
            } else if (wbs_last === source_last) {
              activity.activity_wbs = targetWbs_str;
            }
          }
          else {
            //alert(wbs_last +'='+ target_last +'='+ wbs_last +'='+ source_last);
            if (wbs_last <= target_last && wbs_last > source_last) {
              activity.activity_wbs = wbs_first_str + '.' + (wbs_last - 1).toString();
            }
            else if (wbs_last === source_last) {
              activity.activity_wbs = targetWbs_str;
            }
          }
        }
      });
    }

    else {
      //      if (sourceWbs_str.charAt(0) !== targetWbs_str.charAt(0)) {  //change 2.1 to 3.1
      activityData.forEach(activity => {
        let wbs_first_str = activity.activity_wbs.slice(0, activity.activity_wbs.lastIndexOf('.'));
        let wbs_last_str = activity.activity_wbs.slice(activity.activity_wbs.lastIndexOf('.') + 1);
        let wbs_last = parseInt(wbs_last_str)

        //alert(target_first_str + '=' + wbs_first_str + '=' + wbs_last + '=' + target_last)
        if (source_first_str === wbs_first_str && wbs_last > source_last) {
          activity.activity_wbs = wbs_first_str + '.' + (wbs_last - 1);
        }
        if (target_first_str === wbs_first_str && wbs_last >= target_last) {
          activity.activity_wbs = wbs_first_str + '.' + (wbs_last + 1);
        }
      });

      //Change the source wbs to target wbs
      activityData.forEach((item) => {
        if (item.id === source_id) {
          item.activity_wbs = targetWbs_str;
        }
      });

      //Update children for subtask
      if (src_dotCount > 0) {
        let source_parent_id = activityData.find(item => item.activity_wbs === source_first_str)?.id;
        activityData.forEach((item) => {
          if (item.id === source_parent_id) {
            item.children = item.children?.filter(child => child !== source_id);
          }
          //         if (item.id === 582) {
          //           if (source_id !== undefined && source_id !== null)
          //             item.children?.push(source_id);
          //         }

        });

      }

    }

    return activityData;
  }


  // const handleColumnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const { name, checked } = event.target;

  //   // Update the visibility state of the columns
  //   const updatedColumns = columns.map((col) =>
  //     col.field === name ? { ...col, visible: checked } : col
  //   );

  //   setColumns(updatedColumns);

  //   // Check if the column is Employees or Contractors 
  //   if (ganttChart) {
  //     if (checked) {
  //       ganttChart.showColumn([name]);
  //     } else {
  //       ganttChart.hideColumn([name]);

  //       // Make the respective inputs in the dialog also visible 
  //       // If employees or contractors column is unchecked, you can
  //       // either reset them or just keep them in a hidden state.
  //       // This does not affect the frontend functionality that will work with dialog inputs.
  //     }
  //   }

  //   // Update tasks to reflect the visibility of chart columns
  //   const updatedChartColumns = ChartColumns.map((column) => {
  //     if (column.id === name) {
  //       return { ...column, isVisible: checked };  // Update visibility based on checkbox status
  //     }
  //     return column;
  //   });
  //   setChartColumns(updatedChartColumns);
  // };



  //      const handleColumnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //       const { name, value } = event.target;
  //    //    setSelectedOptions([...selectedOptions, newSelectedOption].filter((value, index) => selectedOptions.indexOf(value) === index));
  //  // Handle the visibility logic for employees and contractors

  //      // For other columns, update the visibility state as usual
  //      setColumns(
  //       columns.map((col) =>
  //          col.field === name ? { ...col, visible: !col.visible } : col
  //        )
  //      );
  //        if (value === 'true') {
  //          const updatedChartColumns = ChartColumns.map((column) => {
  //            if (column.id === name) {
  //              return { ...column, isVisible: false };
  //            }
  //            return column;
  //          });
  //          setChartColumns(updatedChartColumns);
  //        } else {
  //          const updatedChartColumns = ChartColumns.map((column) => {
  //            if (column.id === name) {
  //              return { ...column, isVisible: true };
  //            }
  //            return column;
  //          });
  //          setChartColumns(updatedChartColumns);
  //        }
  //      };

  const handleConfirmClose = (confirmed: boolean) => {
    setConfirmOpen(false);
    // Handle OK/Cancel actions here based on the 'confirmed' value
    if (confirmed) handleDeleteAllActivities();
  };



  const handleDeleteConfirm = () => {
    //open confirmation dialog before deleting all tasks
    setConfirmOpen(true);
  };


  function deleteRow(sourceWbs_str: string): Activity[] {
    //For Main task : 1.1 remove main task  1.2 remove sub tasks of main 1.3 decrease rest of the taks
    //For Sub task : 2.1 remove sub task and its childred  2.2 update the maintaks children

    const sourceWbs = parseInt(sourceWbs_str)

    let src_dotCount = sourceWbs_str.split('.').length - 1;
    let source_first_str = sourceWbs_str.replace(/\.\d+$/, '');  //remove last
    let source_last = parseInt(sourceWbs_str.slice(sourceWbs_str.lastIndexOf('.') + 1));
    let source_id = activityData.find(item => item.activity_wbs === sourceWbs_str)?.id;

    const pattern = new RegExp(`^${sourceWbs_str}(\\.|$)`);
//    let updateActivityData = activityData.filter(item => !pattern.test(item.activity_wbs));

    if (src_dotCount === 0) {  //delete main task
      activityData.forEach(activity => {
        const wbs_parts = activity.activity_wbs.split('.')
        const wbs_main = parseInt(wbs_parts[0]);

        if (wbs_main > sourceWbs) {
          activity.activity_wbs = activity.activity_wbs.replace(/\d+/, (wbs_main - 1).toString());
        }
      });
    }
    else {   // delete sub task 
      activityData.forEach(activity => {
        let wbs_first_str = activity.activity_wbs.slice(0, activity.activity_wbs.lastIndexOf('.'));
        let wbs_last_str = activity.activity_wbs.slice(activity.activity_wbs.lastIndexOf('.') + 1);
        let wbs_last = parseInt(wbs_last_str)

        //alert(target_first_str + '=' + wbs_first_str + '=' + wbs_last + '=' + target_last)
        if (source_first_str === wbs_first_str && wbs_last > source_last) {
          activity.activity_wbs = wbs_first_str + '.' + (wbs_last + 1);
        }
      });

      //Update children for subtask
      if (src_dotCount > 0) {
        let source_parent_id = activityData.find(item => item.activity_wbs === source_first_str)?.id;
        activityData.forEach((item) => {
          if (item.id === source_parent_id) {
            item.children = item.children?.filter(child => child !== source_id);
          }
        });

      }

    }

    return activityData;
  }


  const handleDeleteAllActivities = async () => {
    try {
      setIsLoading(true);
      let projids = [selProjectId];

      const url_delete = BASEURL + `/activity/deleteall/`;
      await axios.delete(url_delete, { data: { projids } });

      let filteredData;
      for (const projectId of projids) {
        filteredData = activityData.filter(
          (activity: any) => activity.project_id !== projectId
        );
      }

      if (filteredData !== undefined) setActivityData(filteredData);
      reset(); //To clear gantt chart and list table values

      setIsLoading(false);
      toast.success('All activities for the selected project are deleted successfully.' );
      //    setEditMode(false);
    } catch (error) {
      toast.error('Something went wrong while deleting all acivities please contact support');
    }
  };

  const reset = () => {
    //After deleting all activities empty state variables
    setActivityData([]);
    setTasks([]);
    // setRowsChartTable([]);
    setRowsListview([]);
  };

  const handleShowBaseline = () => {
    setShowBaseline((showBaseline) => !showBaseline);

  };

  /*
  const handleEditBtn = () => {
    if (editMode) {
      //            updateActivityData()
      saveAllActivities();
    }

    setEditMode((prevEditMode) => !prevEditMode);
  };
*/

  const handleSelectColumn = () => {
    setOpenColumn(true);
  };

  const handleCloseBtn = () => {
    setOpenColumn(false);
    setOpenWBSDialog(false);
  };


  const handlenotifyuser = async () => {
    const url_post = BASEURL + `/send-email-to-users/`;

    try {
      setIsLoading(true);
      setIsButtonVisible(false);
        // Pass the project_id directly in the request body as a key-value pair
        // console.log("selProjectId:",selProjectId);
        const response = await axios.post(url_post, { project_id: selProjectId });
        
        // Handle success, e.g., show a notification or log success
        // console.log("response.data:",response.data);
        const { message } = response.data;
        toast.success(message || 'Activities sent to assigned users'); // Show success toast with the message
    } catch (error) {
        // Handle error
        toast.error('Something went wrong while sending email notifications');
    }finally {
      setIsLoading(false);
      setIsButtonVisible(true);
    }
};



  //Function to export the gantt chart into pdf
  // const exportToPDF = async (args: any) => {

  //    // Set timeline to always display days
  // ganttChart.timelineSettings = {
  //   timelineUnitSize: 60, // Customize as needed
  //   topTier: { unit: 'None' },
  //   bottomTier: { unit: 'Day', format: 'dd/MM/yyyy' },
  // };

  //   const exportProperties = {
  //     header: {
  //       fromTop: 0,
  //       height: 250, // Increased height to accommodate heading, logo, and project name
  //       contents: [
  //         {
  //           type: 'Text',
  //           value: 'Project Schedule Gantt Chart View',
  //           position: { x: 2350, y: 0 }, // Positioning heading at the top
  //           style: {
  //             textBrushColor: '#000000',
  //             fontSize: 25,
  //             fontFamily: 'Poppins, sans-serif',
  //             fontWeight: 'bold',
  //           },
  //         },
  //         {
  //           type: 'Image',
  //           src: logogantt,
  //           position: { x: 0, y: 0 }, // Positioning logo below the heading
  //           size: { height: 80, width: 200 },
  //         },
  //         {
  //           type: 'Text',
  //           value: `Project Name: ${arg_projectname}`,
  //           position: { x: 10, y: 140 }, // Positioning project name below the logo
  //           style: {
  //             textBrushColor: '#000000',
  //             fontSize: 20,
  //             fontFamily: 'Poppins, sans-serif',
  //           },
  //         },
  //       ],
  //     },
  //     footer: {
  //       fromBottom: 160,
  //       height: 100,
  //       contents: [
  //         {
  //           type: 'Text',
  //           value: 'Thank you!',
  //           position: { x: 350, y: 40 },
  //           style: { textBrushColor: '#C67878', fontSize: 14 },
  //         },
  //         {
  //           type: 'PageNumber',
  //           pageNumberType: 'Arabic',
  //           format: 'Page {$current} of {$total}',
  //           position: { x: 0, y: 25 },
  //           size: { height: 50, width: 100 },
  //           style: {
  //             textBrushColor: '#000000',
  //             hAlign: 'Center',
  //             vAlign: 'Bottom',
  //           },
  //         },
  //       ],
  //     },
  //     fitToWidthSettings: {
  //       isFitToWidth: true,
  //     },
  //     pageSize: 'A0',


  //   };

  //   ganttChart.pdfExport(exportProperties);
  // };


  const exportToPDF = async (args: any) => {
    // Save the original timeline setting
    
  
    const exportProperties = {
      header: {
        fromTop: 0,
        height: 250, // Increased height to accommodate heading, logo, and project name
        contents: [
          {
            type: 'Text',
            value: 'Project Schedule Gantt Chart View',
            position: { x: 2350, y: 0 }, // Positioning heading at the top
            style: {
              textBrushColor: '#000000',
              fontSize: 25,
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 'bold',
            },
          },
          {
            type: 'Image',
            src: logogantt,
            position: { x: 0, y: 0 }, // Positioning logo below the heading
            size: { height: 80, width: 200 },
          },
          {
            type: 'Text',
            value: `Project Name: ${arg_projectname}`,
            position: { x: 10, y: 140 }, // Positioning project name below the logo
            style: {
              textBrushColor: '#000000',
              fontSize: 20,
              fontFamily: 'Poppins, sans-serif',
            },
          },
        ],
      },
      footer: {
        fromBottom: 160,
        height: 100,
        contents: [
          {
            type: 'Text',
            value: 'Thank you!',
            position: { x: 350, y: 40 },
            style: { textBrushColor: '#C67878', fontSize: 14 },
          },
          {
            type: 'PageNumber',
            pageNumberType: 'Arabic',
            format: 'Page {$current} of {$total}',
            position: { x: 0, y: 25 },
            size: { height: 50, width: 100 },
            style: {
              textBrushColor: '#000000',
              hAlign: 'Center',
              vAlign: 'Bottom',
            },
          },
        ],
      },
      fitToWidthSettings: {
        isFitToWidth: true,
      },
      pageSize: 'A0',

    //     // Apply timeline settings only for the export
    // timelineSettings: {
    //   topTier: {
    //     format: 'MMM',
    //     unit: 'Month',
    //   },
    //   bottomTier: {
    //     unit: 'Day',
    //     format: 'dd/MM/yyyy',
    //   },
    // },
    };
  
    // Trigger PDF export
    ganttChart.pdfExport(exportProperties);
  
    // Restore the original timeline settings
  };
  

  const exportToExcelGanttchart = async () => {
    ganttChart.excelExport();
  };

  const addLogoAndTitle = (
    doc: jsPDF,
    titleText: string,
    arg_projectname: string
  ) => {
    const docWidth = doc.internal.pageSize.getWidth();
    const logoWidth = 36; // Adjust size as needed
    const logoHeight = 15; // Adjust size as needed

    // Add the logo
    doc.addImage(logo, 'PNG', 12, 12, logoWidth, logoHeight);

    // Calculate the title position
    const titleX = (docWidth - doc.getTextWidth(titleText)) / 2;

    // Add the title
    doc.setFontSize(16);
    doc.text(titleText, titleX, 20);

    // Add project name and created date below the logo
    const projectNameText = `Project Name: ${arg_projectname}`;
    const createdDateText = `Date: ${new Date().toLocaleDateString()}`;
    const projectTextX = 12; // Align with the logo
    const projectNameY = 12 + logoHeight + 10; // Position project name below the logo
    doc.setFontSize(12);
    doc.setFont('Helvetica', 'normal'); // Set font to normal
    doc.text(projectNameText, projectTextX, projectNameY); // Add project name
    const createdDateY = projectNameY + 10; // Position created date below project name
    doc.text(createdDateText, projectTextX, createdDateY); // Add created date

    return createdDateY + 20; // Return the Y position for the next content
  };

  const handleExportPDF = () => {
    const doc = new jsPDF('portrait');
    const docWidth = doc.internal.pageSize.getWidth();
    const docHeight = doc.internal.pageSize.getHeight();
    const margin = 10;

    // Add logo and title
    const report_heading = "Project Schedule List View";
    const nextY = addLogoAndTitle(doc, report_heading, arg_projectname);

    // Draw the border
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(1);
    doc.rect(margin, margin, docWidth - margin * 2, docHeight - margin * 2, 'S');

    let pdfRow = nextY;

    // Add a table with all tasks
    const tableHeaders = ["WBS", "Activity Name", "Start Date", "End Date", "Duration", "Assigned Employees", "Assigned Contractors"];
    const rowsPDF = activityData.map(activity => [
      activity.activity_wbs,
      activity.project_code ? `${activity.project_code} - ${activity.activity_name}` : activity.activity_name,
      activity.activity_start_date,
      activity.activity_end_date,
      activity.activity_duration,
      activity.employees,
      activity.contractors
    ]);

    autoTable(doc, {
      startY: pdfRow + 10, // Ensure enough space after the text
      head: [tableHeaders],
      body: rowsPDF,
      theme: 'grid',
      styles: {
        fontSize: 9,
        cellWidth: 'auto', // Ensures text wrapping
        overflow: 'linebreak' // Ensures text flows to the next line within the cell
      },
      headStyles: {
        fillColor: [202, 255, 89],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
      },
      margin: { top: pdfRow + 10 }, // Ensure the table fits within the page
    });

    doc.save(`Listview_${arg_projectname}.pdf`);
  };

  const exportToExcel = () => {
    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Define the worksheet data
    const wsData = [
      ["WBS", "Activity Name", "Start Date", "End Date", "Duration", "Assigned Employees", "Assigned Contractors"],
      ...activityData.map(activity => [
        activity.activity_wbs,
        activity.project_code ? `${activity.project_code} - ${activity.activity_name}` : activity.activity_name,
        activity.activity_start_date,
        activity.activity_end_date,
        activity.activity_duration,
        activity.employees,
        activity.contractors
      ])
    ];

    // Create a worksheet
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Auto adjust column widths
    const colWidths = wsData[0].map((_, i) => Math.max(...wsData.map(row => row[i] ? row[i].toString().length : 0)) + 2);
    ws['!cols'] = colWidths.map(width => ({ wch: width }));

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "Project Activity Data");

    // Export the workbook to a file
    XLSX.writeFile(wb, `Listview_${arg_projectname}.xlsx`);
  };


  //Choose the color for barcolor in dropdown code
  const chooseColor = ['Purple', 'Yellow', 'Orange', 'Blue', 'Gray', 'Pink'];
  const chooseColorEditParams = {
    params: {
      popupHeight: '200px',
      dataSource: chooseColor,
      mode: 'CheckBox',
      fields: { text: 'value', value: 'value' },
      enableSelectionOrder: false,
    },
  };

  //Customize the bar color code
  function TaskbarTemplate(props: any) {
    const isCritical = props.ganttProperties.isCritical; // Check if the task is on the critical path
    const taskbarColor = isCriticalPathEnabled && isCritical ? 'red' : props.color || 'Black';
    return (
      <div
        className='e-gantt-child-taskbar-inner-div e-gantt-child-taskbar'
        // style={{ height: '100%', backgroundColor: props.color || 'Black' }}
        style={{
          height: '100%',
          backgroundColor: taskbarColor, // Apply the conditional color
        }}
      >
        <div
          className='e-gantt-child-progressbar-inner-div e-gantt-child-progressbar'
          style={{
            width: props.ganttProperties.progressWidth + 'px',
            height: '100%',
            backgroundColor: 'green',
          }}
        ></div>
      </div>
    );
  }

  let elem: any;
let multiSelectEmployeeObj: any;

let multiSelectEmployee = {
  create: () => {
    elem = document.createElement('input');
    return elem;
  },
  read: () => {
    // return multiSelectEmployeeObj.value;
    return multiSelectEmployeeObj.value.length > 0 ? multiSelectEmployeeObj.value : [];
  },
  destroy: () => {
    multiSelectEmployeeObj.destroy();
  },
  write: (args: any) => {
    const fieldData = args.rowData[args.column.field];

    multiSelectEmployeeObj = new MultiSelect({
      dataSource: employees, // your employees array
      mode: 'CheckBox',
      fields: { value: 'employeeName', text: 'employeeName' },
      floatLabelType: 'Always',
      placeholder: 'Employees',
      noRecordsTemplate: "No employees found",  // Custom message when no data
      value: employees.length > 0 && Array.isArray(fieldData)
        ? fieldData
        : typeof fieldData === 'string' && fieldData !== ''
          ? fieldData.split(',')
          : [],  // Do not assign any value if employees array is empty
      change: (event: any) => {
        setSelectedEmployees(event.value); // Update state on selection change
      },
    });
    multiSelectEmployeeObj.appendTo(elem);
  },
};


// Multiselect for contractor field
let elem1: any;
//  let labelElem1: HTMLLabelElement;
let multiSelectContractorsObj: any;
let multiSelectContractors = {
  create: () => {
    elem1 = document.createElement('input');
    return elem1;
  },
  read: () => {
    // return multiSelectContractorsObj.value;
    return multiSelectContractorsObj.value.length > 0 ? multiSelectContractorsObj.value : []; // Ensure value is returned
  },
  destroy: () => {
    multiSelectContractorsObj.destroy();
  },
  write: (args: any) => {
    const fieldData = args.rowData[args.column.field];
    multiSelectContractorsObj = new MultiSelect({
      dataSource: contractors,
      mode: 'CheckBox',
      fields: { value: 'contractorsName', text: 'contractorsName' },
      floatLabelType: 'Always',
      placeholder: 'Contractors',
      noRecordsTemplate: "No contractors found", 
      value: contractors.length > 0 && Array.isArray(fieldData)
      ? fieldData
      : typeof fieldData === 'string' && fieldData !== ''
        ? fieldData.split(',')
        : [], 
      change: (event: any) => {
        setSelectedContractors(event.value); // Update state on selection change
      },
    });
    multiSelectContractorsObj.appendTo(elem1);
  },
};

const labelSettings = {
  // leftLabel: 'TaskID',
  rightLabel: ' ${taskData.TaskName}',
  taskLabel: '${Progress}%',
};


  const beforePdfExport = (args: any) => {
    // Access Gantt's flat data
    // select the column which you need to hide in pdf file and set visible false
    args.ganttObject.treeGrid.columns[10].visible = false;
    args.ganttObject.treeGrid.columns[4].visible = false;
    args.ganttObject.treeGrid.columns[5].visible = false;
    args.ganttObject.treeGrid.columns[6].visible = false;
    args.ganttObject.treeGrid.columns[7].visible = false;
    args.ganttObject.treeGrid.columns[8].visible = false;
    args.ganttObject.treeGrid.columns[9].visible = false;

    // Reduce the width of columns 0, 1, and 2 in the PDF
    args.ganttObject.treeGrid.columns[0].minWidth = 50; // Set desired width for column 0
    args.ganttObject.treeGrid.columns[1].width = 70; // Set desired width for column 1
    args.ganttObject.treeGrid.columns[2].width = 90; // Set desired width for column 2

  };

  /* map the workweek from the workweek data  ------------------------- */
  let workWeek: string[] = []; // Default to an empty array in case localStorage returns null

  if (workweekdays !== null) {
    workWeek = workweekdays
      .replace(/^"|"$/g, '') // Remove leading and trailing quotes
      .split(',')
      .map((day) => day.trim()); // Trim any extra whitespace
  } else {
    console.error('No work week data found in local storage.');
  }

  const selectionSettings: any = {
    type: 'Multiple',
  };

  useEffect(() => {
    function hide() {
      /** hide by HeaderText */
      ganttChart.hideColumn(['Description']);
      ganttChart.hideColumn(['Color']);

    }
    hide(); // Automatically hide the columns when the component is mounted
  }, [ChartColumns,isCriticalPathEnabled,ganttKey]);

  // const autofit  = (args: any) =>  {
  //     if (args.checked) {
  //         isFitToWidth = true;
  //     } else {
  //         isFitToWidth = false;
  //     }
  // }

  const cellEdit = (args: CellEditArgs) => {
    if (!editMode) {
      args.cancel = true; // Prevent inline editing in 'View Only' mode
    }
    if (args.columnName === "StartDate" || args.columnName === "BaselineStartDate") {
      const projectStartDate = new Date(project_startdate); // Replace with your dynamic start date
  
      // Access the editor element after it is rendered
      setTimeout(() => {
        const datePickerElement = document.querySelector<HTMLInputElement>(".e-input.e-datepicker"); // Query the DatePicker element in the DOM
        if (datePickerElement) {
          const datePickerInstance = (datePickerElement as any).ej2_instances?.[0]; // Access the DatePicker instance
          if (datePickerInstance) {
            datePickerInstance.min = projectStartDate; // Set the minimum date
            if (project_enddate) {
              datePickerInstance.max = project_enddate; // Set the maximum date if defined
            }
            datePickerInstance.refresh(); // Refresh the DatePicker to apply changes
          }
        }
      }, 0); // Timeout ensures the editor is fully initialized
    }
  };


  return (
    <ThemeProvider theme={getTheme()}>
      <div>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color='inherit' />
        </Backdrop>

        {confirmOpen ? (
          <ConfirmationDialog
            confirmOpen={confirmOpen}
            title='BrixPro - Confirm Deletion'
            message='Are you sure you want to delete all Activities?'
            onClose={handleConfirmClose}
          />
        ) : null}

        <Box sx={{ marginTop: '0%', marginBottom: '0%' }}>
          <Box
            sx={{
              marginLeft: '100px',
              marginTop: '0px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {selChartView === 0 ? (
              <Box sx={{ marginLeft: '30px', marginBottom: '10px' }}>
                <Grid
                  container
                  spacing={2}
                  justifyContent='center'
                  alignItems='center'
                >
                  {/* <Grid item>
                    <Button variant='contained' onClick={handleSelectColumn}>
                      Select Columns
                    </Button>
                  </Grid> */}
                  <Grid item>
                    <Button variant='contained' onClick={exportToPDF}>
                      Export to PDF
                    </Button>
                  </Grid>

                  <Grid item>
                    <Button
                      variant='contained'
                      onClick={exportToExcelGanttchart}
                    >
                      Export to Excel
                    </Button>
                  </Grid>

                  <Grid item>
                    <Button variant='contained' onClick={handleShowBaseline}>
                      {showBaseline ? 'Hide Baseline' : 'Show Baseline'}
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button variant='contained'sx={{ mt: 2, mb: 2, '&:disabled': { bgcolor: 'grey.400', color: 'grey.700' } ,
                    opacity: scheduleAccess === 'Owner' || scheduleAccess === 'Edit' ? 1 : 0.5}}
                     onClick={handlenotifyuser}
                    disabled={!(scheduleAccess === 'Owner' || scheduleAccess === 'Edit')||!isButtonVisible}>
                      Notify Users
                    </Button>
                  </Grid>

                  {/* {is_admin || scheduleAccess.toLowerCase() === 'owner' ? ( */}
                  {/* 
                  <Grid item>
                    <Button variant='contained' onClick={handleEditBtn}>
                      {editMode ? 'Save' : 'Edit'}
                    </Button>
                  </Grid>
              */}
                  {/* ) : null} */}
                </Grid>
              </Box>
            ) : null}

            <Box
              sx={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end' }}
            >
              <StyledSelect value={selChartView} onChange={onListChange}>
                <MenuItem value={0}>CHART VIEW</MenuItem>
                {/* <MenuItem value={1}> Calendar View </MenuItem> */}
                <MenuItem value={2}> LIST VIEW </MenuItem>
              </StyledSelect>
            </Box>

            {selChartView === 0 ? (
              <Box sx={{ marginLeft: 'auto' }}>
                <IconButton
                  aria-controls='simple-menu'
                  aria-haspopup='true'
                  onClick={(event) => setAnchorEl(event.currentTarget)}
                  sx={{ marginRight: '10px',
                    opacity: scheduleAccess !== 'Owner' ? 0.5 : 1
                   }}
                  disabled={scheduleAccess !== 'Owner'}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id='simple-menu'
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={() => setAnchorEl(null)}
                >
                  <MenuItem onClick={handleDeleteConfirm}>Delete</MenuItem>
                </Menu>
              </Box>
            ) : null}
          </Box>
        </Box>

        <Box sx={{ marginTop: '0%' }}>
          {selChartView === 1 ? (  //for calendar view
            <div style={{ height: 400, marginTop: '0%', margin: '10px', marginLeft: '-1px' }}>
              {/*                
                            <Calendar
                                localizer={localizer}
                                events={taskDetails || []} // Use an empty array if taskDetails is null
                                startAccessor="start"
                                endAccessor="end"
                                //    views={['week']}
                                defaultView="month"
                                titleAccessor="title"
                                views={['month', 'week', 'day']}
                            />
*/}
            </div>
          ) : (null)
          }

          {selChartView === 2 ? ( //for list view
            <div
              style={{ marginTop: '0%', margin: '10px', marginLeft: '-1px' }}
            >
              <Button
                variant='contained'
                onClick={handleExportPDF}
                sx={{ marginLeft: '50px', marginBottom: '20px' }}
              >
                Export to PDF
              </Button>
              <Button
                variant='contained'
                onClick={exportToExcel}
                sx={{ marginLeft: '20px', marginBottom: '20px' }}
              >
                Export to Excel
              </Button>
              <Grid item md={6} xs={12}>
                <BasicTable columns={ListviewColumn} rows={rows_listview} /> 
              
              </Grid>
            </div>
          ) : null}

          {/* <Dialog open={openColumn} onClose={handleCloseBtn}>
            <DialogTitle>Select Columns</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Choose the columns you want to display.
              </DialogContentText>
              {ChartColumns.map((option) => (
                <FormControlLabel
                  key={option.id}
                  control={
                    <Checkbox
                      checked={option.isVisible}
                      onChange={handleColumnChange}
                      value={option.isVisible}
                    />
                  }
                  label={option.label}
                  name={option.id}
                />
              ))}
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseBtn} variant='contained'>
                Close
              </Button>
            </DialogActions>
          </Dialog> */}


          <Dialog open={openWBSDialog} onClose={handleCloseBtn}>
            <DialogTitle>Change WBS</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Please enter source and target WBS Number.
              </DialogContentText>

              <Grid container spacing={2}>
                <Grid item md={5} xs={12}>
                  <label htmlFor="src_wbs">Source WBS:</label>
                </Grid>
                <Grid item md={7} xs={12}>
                  <TextField
                    value={sourceWBS}
                    onChange={handleSourceWBSChange}
                    fullWidth
                    variant="outlined"
                    name="source_wbs"
                    sx={{
                      textAlign: "center", textJustify: "center", width: { sm: 200, md: 250 }, "& .MuiInputBase-root": { height: 40 }
                    }}
                  />
                </Grid>

                <Grid item md={5} xs={12}>
                  <label htmlFor="target_wbs">Target WBS:</label>
                </Grid>
                <Grid item md={7} xs={12}>
                  <TextField
                    value={targetWBS}
                    onChange={handleTargetWBSChange}
                    fullWidth
                    variant="outlined"
                    name="target_wbs"
                    sx={{
                      textAlign: "center",
                      textJustify: "center",
                      width: { sm: 200, md: 250 },
                      "& .MuiInputBase-root": { height: 40 }
                    }}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>

              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button variant='contained' onClick={handleChangeWBS} sx={{ marginRight: '10px' }}>
                  Save
                </Button>
                <Button onClick={handleCloseBtn} type='submit' variant='contained' color='primary'>
                  Cancel
                </Button>
              </Box>
            </DialogActions>
          </Dialog>




          {/* <ButtonComponent onClick= { hide }>Hide</ButtonComponent> */}
          {/* <SwitchComponent id="unchecked" checked={false} change={autofit.bind(this)}></SwitchComponent> */}
          {selChartView === 0 ? (
            <Box sx={{ marginTop: '20px' }}>
              {/* <div> */}
              <div id="gantt-container-wrapper">
                <GanttComponent
                  key={ganttKey}
                  dataSource={tasks}
                  taskFields={taskFields}
                  allowSelection={true}
                  id='gantt-container'
                  editSettings={{
                    allowEditing: true,
                    allowAdding: true,
                    allowDeleting: true,
                    allowTaskbarEditing: editMode,
                    mode: 'Auto',
                  }}
                  toolbar={toolbarOptions}
                  enableUndoRedo={true}
                  enableCriticalPath={true}
                  taskbarTemplate={TaskbarTemplate}
                  labelSettings={labelSettings}
                  beforePdfExport={beforePdfExport}
                  // pdfExportComplete ={pdfExportComplete}
                  projectStartDate={startDateproject}
                  projectEndDate={endDateproject}
                  splitterSettings={splitterSettings}
                  gridLines='Both'
                  //allowRowDragAndDrop={true}
                  allowResizing={true}
                  selectionSettings={selectionSettings}
                  highlightWeekends={true}
                  workWeek={workWeek}
                  actionComplete={actionComplete}
                  allowPdfExport={true}
                  height='450px'
                  width='100%'
                  allowExcelExport={true}
                  actionBegin={actionBegin}
                  toolbarClick={toolbarClick}
//                  enableVirtualization={true}
                  enableVirtualization={false}
                  allowReordering={true}
                  baselineColor='red'
                  treeColumnIndex={1}
                  renderBaseline={showBaseline ? true : false}
                  ref={(gantt) => (ganttChart = gantt)}
                  cellEdit={cellEdit}
                >
                  <Inject
                    services={[
                      Edit,
                      Selection,
                      PdfExport,
                      Toolbar,
                      UndoRedo,
                      CriticalPath,
                      VirtualScroll,
                      ExcelExport,
                      RowDD,
                      DayMarkers,
                      Resize,
                      Reorder
                    ]}
                  />

                  <ColumnsDirective>
                    {columns.map((col) =>
                      col.visible ? (
                        <ColumnDirective
                          key={col.field}
                          field={col.field}
                          headerText={col.headerText}
                          width={col.width}
                          isPrimaryKey={col.isPrimaryKey}
                          format={col.format}
                          editType={
                            col.field === 'BaselineDuration'
                              // col.field === 'Duration'
                              ? 'numericedit'
                              : col.field === 'color'
                                ? 'dropdownedit'
                                : undefined
                          }
                          edit={
                            col.field === 'color'
                              ? chooseColorEditParams
                              : col.field === 'employees'
                                ? multiSelectEmployee
                                : col.field === 'contractors'
                                  ? multiSelectContractors
                                  : col.field === 'BaselineDuration'
                                    ? { params: { step: 1, min: 0, value: 1 } }
                                    // : col.field === 'Duration'
                                    //   ? {
                                    //       params: { step: 1, min: 0, value: 1 },
                                    //     }
                                    : undefined
                          }
                        />
                      ) : null
                    )}
                  </ColumnsDirective>
                  {/* map the holidaydatesandlabel  ------------------------- */}
                  <HolidaysDirective>
                    {holidayDatesandLabels.map((holiday: any, index: any) => (
                      holiday.from && holiday.to ? (
                        <HolidayDirective
                          key={index}
                          from={holiday.from}
                          to={holiday.to}
                          label=""
                        />
                      ) : null // Skip invalid holiday objects
                    ))}
                  </HolidaysDirective>

                  <AddDialogFieldsDirective>
                    <AddDialogFieldDirective
                      type='General'
                      headerText='General'
                      fields={[
                        'TaskID',
                        'TaskName',
                        'Description',
                        'employees',
                        'contractors',
                        'StartDate',
                        'Duration',
                        'BaselineStartDate',
                        'BaselineDuration',
                        'Progress',
                        'color',
                      ]}
                    ></AddDialogFieldDirective>
                    <AddDialogFieldDirective type='Dependency'></AddDialogFieldDirective>
                  </AddDialogFieldsDirective>

                  <EditDialogFieldsDirective>
                    <EditDialogFieldDirective
                      type='General'
                      headerText='General'
                      fields={[
                        'TaskID',
                        'TaskName',
                        'Description',
                        'employees',
                        'contractors',
                        'StartDate',
                        'Duration',
                        'BaselineStartDate',
                        'BaselineDuration',
                        'Progress',
                        'color',
                      ]}
                    ></EditDialogFieldDirective>
                    <EditDialogFieldDirective type='Dependency'></EditDialogFieldDirective>
                  </EditDialogFieldsDirective>
                </GanttComponent>
              </div>
            </Box>
          ) : null}
        </Box>

        <FloatingButton />
      </div>
    </ThemeProvider>
  );
};
export default ProjectScheduleEdit2;